export enum SearchArmyActionTypes {
  ADD_SEARCH_RESULT = "search.add.result",
  ADD_MULTIPLE_RESULTS = "search.add.multiple.results",
  START_NEW_SEARCH = "search.start",
  FINISHED_SEARCH = "search.finished",
  ABORT_SEARCH = "search.aborted",
}
